/* مساعد موحّد لتصغير الصور حسب مكان عرضها — يقطع حجم التحميل حتى 80% */
export function optimizeImg(url, w = 600) {
  if (!url || typeof url !== "string" || url.startsWith("data:")) return url;
  try {
    if (url.startsWith("/api/images/") || url.includes("/api/images/")) {
      return `${url}${url.includes("?") ? "&" : "?"}w=${w}`;
    }
    if (url.includes("res.cloudinary.com") && url.includes("/image/fetch/")) {
      const [head, rest] = url.split("/image/fetch/");
      const slash = rest.indexOf("/");
      if (slash > 0) {
        let t = rest.slice(0, slash);
        const enc = rest.slice(slash + 1);
        t = /(^|,)w_\d+/.test(t) ? t.replace(/(^|,)w_\d+/, `$1w_${w}`) : `${t},w_${w}`;
        if (w <= 600) t = t.replace("q_auto:good", "q_auto:eco");
        return `${head}/image/fetch/${t}/${enc}`;
      }
    }
    if (url.includes("images.unsplash.com")) {
      const u = new URL(url);
      u.searchParams.set("auto", "format");
      u.searchParams.set("fm", "webp");
      u.searchParams.set("q", w <= 480 ? "60" : "70");
      u.searchParams.set("w", String(w));
      u.searchParams.set("fit", "crop");
      return u.toString();
    }
  } catch { /* keep original on parse failure */ }
  return url;
}
